<template>
  <vue-excel-xlsx
      :data="data"
      :columns="columns"
      :file-name="fileNameProp"
      :file-type="'xlsx'"
      :sheet-name="'Kitaplık 1'"
  >
    <v-btn text color="success darken-2" :disabled="buttonEnabled">
      <v-icon left>mdi-microsoft-excel</v-icon>
      {{buttonTitle}}
    </v-btn>
  </vue-excel-xlsx>
</template>

<script>
export default {
  name: "ExcelExport.vue",
  props:{
    dataProp:{
      type: [Array, Boolean],
      default: () =>  []
    },
    columnProp:{
      type: [Array, Boolean],
      default: () =>  []
    },
    fileNameProp:{
      type: String,
      default: "exportxlsx"
    },
    sheetNameProp:{
      type: String,
      default: "sheet"
    },
    buttonTitle: {
      type: String,
      required: false,
      default: 'Excel'
    },
    buttonEnabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data(){
    return {
      columns:[],
      data:[]
    }
  },
  methods:{
    setColumns(cols = []){
      this.columns = cols.map(item => {

        return {
          label: item.label,
          field: item.key
        }
      })
    },
    setData(datas){
      this.data = datas.map(item => {
        return item
      })
    }
  },
  watch:{
    dataProp: function(newVal){
      if(!newVal ||newVal.length < 1)
        return;
      this.setData(newVal);
    },
    columnProp: function(newVal){
      if(!newVal ||newVal.length < 1)
        return;
      this.setColumns(newVal);
    }
  }
}
</script>

<style scoped>

</style>